import { cloneDeep } from "lodash";
import { UserWhoami } from "../api";
import type { ClankPermissions } from "../api/types";

const empty_user: UserWhoami = {
  id: "-1",
  username: "__null",
  first_name: "No",
  last_name: "User",
  email: "example@example.com",
  prompt: "",
  external_auth_issuer: null,
  external_auth_subject: null,
  date_created: new Date().toISOString(),
  last_login: null,
  _updated_at: new Date().toISOString(),
  company_id: null,
  csrf_token: "empty_user_invalid",
  early_adopter: "releases",
};

export const PERFORM_LOGIN = "PERFORM_LOGIN";
export const REQUEST_NEW_LOGIN = "REQUEST_NEW_LOGIN";

const empty_permissions: ClankPermissions = {
  recordings: { visualization: "OnlyMine" },
  processes: { visualization: "OnlyMine" },
  screenshots: { visualization: "OnlyMine" },
  users: { visualization: "OnlyMine", creation: false },
  is_admin: false,
};

export interface LoginState {
  needs_login_again: boolean;
  logged_in: boolean;
  user: UserWhoami;
  permissions: ClankPermissions;
}

export interface performLoginAction {
  type: typeof PERFORM_LOGIN;
  user: UserWhoami;
  permissions: ClankPermissions;
}

export interface RequestNewLoginAction {
  type: typeof REQUEST_NEW_LOGIN;
}

export function set_user_data(user: UserWhoami, permissions: ClankPermissions): performLoginAction {
  return { type: PERFORM_LOGIN, user, permissions };
}

export function request_new_login_action(): RequestNewLoginAction {
  return { type: REQUEST_NEW_LOGIN };
}

export function loginReducer(
  state: LoginState = {
    logged_in: false,
    needs_login_again: false,
    user: cloneDeep(empty_user),
    permissions: cloneDeep(empty_permissions),
  },
  action: performLoginAction,
) {
  if (action.type == PERFORM_LOGIN) {
    return Object.assign({}, state, {
      logged_in: true,
      needs_login_again: false,
      user: action.user,
      permissions: action.permissions,
    });
  } else if (action.type == REQUEST_NEW_LOGIN) {
    return {
      ...state,
      needs_login_again: true,
    };
  } else {
    return state;
  }
}
